(function(){function syncHingePair(degree,type){if(!degree||!type)return;const inset=Array.from(type.options).find(option=>option.value==="Inset");if(!inset)return;const unavailable=degree.value==="155";inset.disabled=unavailable;inset.hidden=unavailable;if(unavailable&&type.value==="Inset")type.value="Lay-on";}function sync(){const degree=document.querySelector("#hingeDegreeSelect"),type=document.querySelector("#hingeOptionSelect");const previous=type?.value;syncHingePair(degree,type);if(type&&type.value!==previous)type.dispatchEvent(new Event("change",{bubbles:true}));}document.addEventListener("change",event=>{if(event.target.matches("#hingeDegreeSelect,#hingeOptionSelect"))sync();},true);document.addEventListener("DOMContentLoaded",sync);sync();})();
class DoorBuilder {
  constructor() {
    this.init();
  }

  // Initialize, check URL parameters and attach click events
  init() {
    if (!window.location.href.includes('cart')) {
      this.initializeBuilderFlowSteps();
      this.checkUrlForStyle();
    }

    this.setInitialValues();

    // Click events
    this.attachStepEventListeners();
    this.attachClickEventToCards();
    this.attachToggleEventToBooleanElements();
    this.attachInputChangeEvents();
    this.attachBuyNowClickEvent();
  }

  // Initialize visibility for builder--flow steps
  initializeBuilderFlowSteps() {
    const builderFlowSteps = document.querySelectorAll('.builder--flow');
    const reviewBuilderElements = document.querySelectorAll('.builder--review');

    builderFlowSteps.forEach((step, index) => {
      if (index === 0) {
        step.classList.add('builder--flow-first');
        step.classList.add('active');
        step.classList.remove('hidden');
      } else {
        step.classList.add('hidden');
      }

      // Add 'builder--flow-last' class to the last builder--flow element
      if (index === builderFlowSteps.length - 1) {
        step.classList.add('builder--flow-last');
      }
    });

    // Hide all review--builder elements
    reviewBuilderElements.forEach((element) => {
      element.classList.add('hidden');
    });

    this.updateStepButtonVisibility();
  }

  // Check URL for 'style' parameter and update dataset
 checkUrlForStyle() {
  const urlParams = new URLSearchParams(window.location.search);
  let urlStyle = urlParams.get('style');

  if (urlStyle === null) {
    urlStyle = 'plain-shaker';
  }

  const style = document.querySelector('[data-style="' + urlStyle + '"]');

  this.makeActiveAndUpdateTime(style);
  this.updateWindowBuilder('style', urlStyle);

  // If a style was passed in the URL, skip straight to the next step
if (urlParams.get('style') !== null) {
  setTimeout(() => this.nextStep(), 50);
}
}

  // Set initial values and update the window object
  setInitialValues() {
    // Find all boolean option groups and set their initial state
    const booleanOptionGroups = document.querySelectorAll('[data-object]');
    booleanOptionGroups.forEach((group) => {
      const activeOption = group.querySelector('.button.active');
      if (activeOption) {
        const booleanValue = activeOption.dataset.boolean;
        const objectKey = group.dataset.object;
        this.updateWindowBuilder(objectKey, booleanValue);
      }
    });
  }

  // Method to attach event listeners to the step buttons
  attachStepEventListeners() {
    const lastStepButton = document.querySelector('.lastStep');
    const nextStepButton = document.querySelector('.nextStep');

    if (lastStepButton) {
      lastStepButton.addEventListener('click', () => this.lastStep());
    }
    if (nextStepButton) {
      nextStepButton.addEventListener('click', () => this.nextStep());
    }
  }

  // Attach click events to elements with a 'data-style' attribute
  attachClickEventToCards() {
    const cards = document.querySelectorAll('[data-style]');
    cards.forEach((card) => {
      card.addEventListener('click', () => {
        this.makeActiveAndUpdateTime(card);
      });
    });
  }

  // Attach click events to elements with a 'data-boolean' attribute
  attachToggleEventToBooleanElements() {
    const booleanElements = document.querySelectorAll('[data-boolean]');
    booleanElements.forEach((element) => {
      element.addEventListener('click', () => {
        this.handleBooleanElementClick(element);
      });
    });
  }

  // Handle actions when a boolean element is clicked
  handleBooleanElementClick(element) {
    // Update active status for boolean buttons
    const booleanButtons =
      element.parentElement.querySelectorAll('[data-boolean]');
    booleanButtons.forEach((btn) => {
      btn.classList.remove('active');
    });
    element.classList.add('active');

    // Check for the closest parent with 'data-parent' and toggle visibility
    // of 'data-child' elements based on the boolean value
    const parentValue = element.closest('[data-parent]')?.dataset.parent;
    const booleanValue = element.dataset.boolean;

    // Handle visibility for "yes" or "custom" boolean values
    const childElementsYes = document.querySelectorAll(
      `[data-child='${parentValue}']`
    );
    const childElementsNo = document.querySelectorAll(
      `[data-child-alternate='${parentValue}']`
    );

    if (parentValue) {
      if (booleanValue === 'yes' || booleanValue === 'custom') {
        childElementsYes.forEach((child) => child.classList.remove('hidden'));
        childElementsNo.forEach((child) => child.classList.add('hidden')); // Ensure 'no' specific children are hidden in this case
      } else if (booleanValue === 'no') {
        childElementsYes.forEach((child) => child.classList.add('hidden')); // Hide 'yes' specific children
        childElementsNo.forEach((child) => child.classList.remove('hidden')); // Show 'no' specific children
      } else {
        // Handle default or other cases as needed
        childElementsYes.forEach((child) => child.classList.add('hidden'));
        childElementsNo.forEach((child) => child.classList.add('hidden'));
      }
    }

    // Retrieve the object name from the closest parent with 'data-object'
    const objectKey =
      element.closest('[data-object]')?.dataset.object || 'defaultKey';
    this.updateWindowBuilder(objectKey, booleanValue);
    this.updateStepButtonVisibility(false);

    this.updateFeaturedImageOptions(element);
  }

  updateFeaturedImageOptions(optionElement) {
    // Get the height value from the height input
    const heightInput = document.querySelector('input[name="heightmm"]');
    const heightValue = heightInput ? parseInt(heightInput.value, 10) : 0;

    // Determine which option is active based on the passed element
    const activeOption = optionElement.getAttribute('data-option');

    // Find the nearest .builder-card--four-image element
    const imageContainer = optionElement
      .closest('.builder-card--four')
      .querySelector('.builder-card--four-image');

    // Determine the correct dataset key based on the heightValue and active option
    let datasetKey;
    if (heightValue >= 1600) {
      datasetKey = activeOption === '1' ? 'imagethree' : 'imagefour';
    } else {
      datasetKey = activeOption === '1' ? 'imageone' : 'imagetwo';
    }

    // Update the innerHTML of the .builder-card--four-image with the dataset that matches
    if (imageContainer && imageContainer.dataset[datasetKey]) {
      imageContainer.innerHTML = imageContainer.dataset[datasetKey];
    }
  }

  // Attach change events to input and textarea elements
  attachInputChangeEvents() {
    // Query all input and textarea elements
    const inputElements = document.querySelectorAll('input, textarea');

    inputElements.forEach((element) => {
      element.addEventListener('change', (event) => {
        if (event.target.tagName.toLowerCase() === 'input') {
          this.handleInputChange(event.target);
        } else if (event.target.tagName.toLowerCase() === 'textarea') {
          this.handleTextareaChange(event.target);
        }

        this.updateStepButtonVisibility(false);

        // Check if the changed input is 'heightmm'
        const closestDimensionsCard = event.target.closest(
          '.builder-card--three[data-object="dimensions"]'
        );

        if (event.target.name === 'heightmm' && closestDimensionsCard) {
          const heightValue = event.target.value;
          // Ensure heightValue is a number and not just whitespace before calling the function
          if (!isNaN(heightValue) && heightValue.trim() !== '') {
            this.updateFeaturedImageOptionsHeight(Number(heightValue));
            // Call the new method for midrail handling
            this.handleMidrailVisibilityAndHeight(Number(heightValue));
          }
        }
      });
    });
  }

  // Handle midrail visibility and midrail height max
  handleMidrailVisibilityAndHeight(heightValue) {
    // Directly query the document for the midrailType element
    const midrailTypeElement = document.querySelector(
      '[data-object="midrail"]'
    );

    // Assume window.builder.style holds the current selected style name
    const currentStyle = window.builder?.style;

    // Define styles for which the midrailType should be hidden
    const stylesToHideMidrail = [
      'Jacobean Shaker',
      'Beaded Jacobean',
      'Arts And Crafts',
      'Beaded Arts And Crafts',
      'Flat',
      'Finger Pull',
      'Flat Tongue And B Groove',
      'Flat Tongue And V Groove',
    ];

    if (heightValue >= 1600 && !stylesToHideMidrail.includes(currentStyle)) {
      midrailTypeElement?.classList.remove('hidden');
    } else {
      midrailTypeElement?.classList.add('hidden');
    }

    // Direct query for midrailHeight and set max value
    const midrailHeightElement = document.querySelector(
      '[data-object="midrailHeight"] input'
    );
    if (midrailHeightElement) {
      midrailHeightElement.max = heightValue; // Set the max attribute to the height value
    }
  }

  // Handle actions when an input element changes
  handleInputChange(inputElement) {
    // Find the nearest parent container
    const parentElement = inputElement.closest('.builder-card--three');
    const heightInput = parentElement.querySelector('input[name="heightmm"]');
    const widthInput = parentElement.querySelector('input[name="widthmm"]');

    // Get values if inputs are found
    let heightValue = heightInput ? heightInput.value : '';
    let widthValue = widthInput ? widthInput.value : '';

    // Handle input max
    const max = parseInt(inputElement.getAttribute('max'), 10);
    const min = parseInt(inputElement.getAttribute('min'), 10);

    // Calculate whether to leave error message
    let valueAdjusted = false;
    let originalValue = parseInt(inputElement.value, 10);

    if (originalValue > max) {
      inputElement.value = max;
      valueAdjusted = true;
    } else if (originalValue < min) {
      inputElement.value = min;
      valueAdjusted = true;
    }

    // Display alert if value was adjusted
    // Display alert if value was adjusted
    if (valueAdjusted) {
      this.displayAdjustmentAlert(
        inputElement,
        originalValue,
        inputElement.value
      );

      // Check if the input element is for width or height and update the value accordingly
      if (inputElement.name === 'heightmm') {
        heightValue = inputElement.value; // Update the height value
      } else if (inputElement.name === 'widthmm') {
        widthValue = inputElement.value; // Update the width value
      }

      // Update the data-object with the new values
      this.updateDataObject(parentElement, heightValue, widthValue);
    } else {
      const existingAlert = document.querySelector('.input-alert');
      if (existingAlert) {
        existingAlert.remove();
      }
      this.updateDataObject(parentElement, heightValue, widthValue);
    }
  }

  // Handle actions when a textarea element changes
  handleTextareaChange(textareaElement) {
    // Find the nearest parent container
    const parentElement = textareaElement.closest('.builder-card--seven');

    // Calculate whether to leave error message
    const originalValue = textareaElement.value;

    this.updateDataObject(parentElement, originalValue, null);
  }

  displayAdjustmentAlert(inputElement, originalValue, adjustedValue) {
    // Find the nearest parent '.builder-card--three' and then find '.builder-card--three-content' within it
    const parentElement = inputElement.closest('.builder-card--three');
    const targetContainer = parentElement.querySelector(
      '.builder-card--three-content'
    );

    // Remove existing alert if present to avoid duplicate messages
    const existingAlert = targetContainer.querySelector('.input-alert');
    if (existingAlert) {
      existingAlert.remove();
    }

    // Create the alert message
    const alertParagraph = document.createElement('p');
    alertParagraph.classList.add('input-alert'); // Use this class for styling the alert
    alertParagraph.textContent = `Your input of ${originalValue} was adjusted to ${adjustedValue} to meet the requirements.`;
    alertParagraph.style.color = 'red'; // Example styling, adjust as needed

    // Append the alert paragraph to the bottom of '.builder-card--three-content'
    targetContainer.appendChild(alertParagraph);
  }

  // Handle featured image change for options
  updateFeaturedImageOptionsHeight(height) {
    // Find all .builder-card--four-options elements
    const optionsContainers = document.querySelectorAll(
      '.builder-card--four-options'
    );

    optionsContainers.forEach((container) => {
      // Determine which option is active
      const activeOption = container
        .querySelector('.active')
        .getAttribute('data-option');

      // Find the nearest .builder-card--four-image element
      const imageContainer = container
        .closest('.builder-card--four')
        .querySelector('.builder-card--four-image');

      // Determine the correct dataset based on the height and active option
      let datasetKey;
      if (height >= 1600) {
        datasetKey = activeOption === '1' ? 'imagethree' : 'imagefour';
      } else {
        datasetKey = activeOption === '1' ? 'imageone' : 'imagetwo';
      }

      // Update the innerHTML of the .builder-card--four-image with the dataset that matches
      if (imageContainer && imageContainer.dataset[datasetKey]) {
        imageContainer.innerHTML = imageContainer.dataset[datasetKey];
      }
    });
  }

  // Update the closest data-object based on height and width values
  updateDataObject(parentElement, height, width) {
    const objectKey = parentElement.dataset.object || 'defaultKey';
    let combinedValue = '';

    if (objectKey === 'hingeCustomPositions') {
      combinedValue = height;
    } else if (height && width) {
      combinedValue = `Height: ${height}, Width: ${width}`;
    } else if (height) {
      combinedValue = `Height: ${height}`;
    } else if (width) {
      combinedValue = `Width: ${width}`;
    }

    this.updateWindowBuilder(objectKey, combinedValue);
  }

  makeActiveAndUpdateTime(card) {
    // Define the styles that require special handling at the start
    const stylesToDisable = [
      'Jacobean Shaker',
      'Beaded Jacobean',
      'Arts and Crafts',
      'Beaded Arts and Crafts',
    ];

    // Check whether the door is disabled
    let isStyleToDisable = false;

    document.querySelectorAll('[data-style]').forEach((item) => {
      // Get the product title for each item
      const itemTitleValue =
        item.parentElement.querySelector('[data-title]').dataset.title;

      // Reasign disable variable if needed
      isStyleToDisable = stylesToDisable.includes(itemTitleValue);

      // Remove active state from all items
      item.classList.remove('active');

      // Use the condition here to change innerHTML based on whether the style is to be hidden
      item.innerHTML = isStyleToDisable ? 'Call Us' : 'Select';

      // Add class to item that has call us
      item.classList.add(isStyleToDisable ? 'disabled' : 'abled');
    });

    // Add active class and update text tot selected
    card.classList.add('active');
    card.innerHTML = 'Selected';

    // Get the option for the next button title and title in header
    const selectedOptionContainers = document.querySelectorAll(
      '.builder--data-selected-option'
    );

    // Get the product title for specific card
    const prodTitleValue =
      card.parentElement.querySelector('[data-title]').dataset.title;

    // Update all title options on page
    selectedOptionContainers.forEach((item) => {
      item.innerHTML = prodTitleValue;
    });

    // Get door style
    const style = card.dataset.style;

    // Update door settings
    this.updateUrlParameter(style);
    this.updateWindowBuilder('style', style);
    this.updateWindowVariantId(card);
  }

  // Update the URL parameter based on the selected style
  updateUrlParameter(style) {
    const url = new URL(window.location);
    url.searchParams.set('style', style);
    window.history.pushState({}, '', url.toString());
  }

  // Update window.variantId based on the dataset.variant of the clicked card
  updateWindowVariantId(card) {
    const variantId = card.dataset.variant || 'default';
    this.updateWindowBuilder('variantId', variantId);
  }

  // Method for handling 'lastStep' action
  lastStep() {
    const currentActive = document.querySelector('.builder--flow.active');
    const nextStepButton = document.querySelector('.nextStep');
    const buyDoorButton = document.querySelector('.buyDoor'); // Assuming there's a button with class 'buyDoor'

    if (currentActive) {
      const previousSibling = currentActive.previousElementSibling;
      if (
        previousSibling &&
        previousSibling.classList.contains('builder--flow')
      ) {
        currentActive.classList.remove('active');
        currentActive.classList.add('hidden');
        previousSibling.classList.add('active');
        previousSibling.classList.remove('hidden');

        // Check if the previous element is not the last step
        const isPreviousNotLastStep =
          !previousSibling.classList.contains('builder--flow-last');
        if (isPreviousNotLastStep) {
          if (nextStepButton) nextStepButton.classList.remove('hidden');
          if (buyDoorButton) buyDoorButton.classList.add('hidden');
        }

        this.updateStepButtonVisibility();
      }
    }
  }

  // Method for handling 'nextStep' action
  nextStep() {
    const currentActive = document.querySelector('.builder--flow.active');
    const nextStepButton = document.querySelector('.nextStep');
    const buyDoorButton = document.querySelector('.buyDoor'); // Assuming there's a button with class 'buyDoor'

    if (!currentActive) {
      return;
    }

    const nextElement = currentActive.nextElementSibling;
    const isNextLastStep =
      nextElement && nextElement.classList.contains('builder--flow-last');

    if (nextElement && nextElement.classList.contains('builder--flow')) {
      // Move to the next step
      currentActive.classList.remove('active');
      currentActive.classList.add('hidden');
      nextElement.classList.add('active');
      nextElement.classList.remove('hidden');

      // Update button visibility based on whether the next element is the last step
      if (isNextLastStep) {
        if (nextStepButton) nextStepButton.classList.add('hidden');
        if (buyDoorButton) buyDoorButton.classList.remove('hidden');
      } else {
        if (nextStepButton) nextStepButton.classList.remove('hidden');
        if (buyDoorButton) buyDoorButton.classList.add('hidden');
      }
    } else {
      // Handle the case where current step is already the last
      if (nextStepButton) nextStepButton.classList.add('hidden');
      if (buyDoorButton) buyDoorButton.classList.remove('hidden');
    }

    this.updateStepButtonVisibility();
  }

  updateStepButtonVisibility(shouldScroll = true) {
    const firstStep = document.querySelector('.builder--flow-first');
    const lastStepButton = document.querySelector('.lastStep');
    const buyDoorButton = document.querySelector('.buyDoor');

    // Only validate visible inputs in the active builder step.
    // The previous global selector also picked up unrelated footer/cart fields,
    // which could leave Buy Door permanently disabled.
    const activeFlowForValidation = document.querySelector('.builder--flow.active');
    const allFields = activeFlowForValidation
      ? activeFlowForValidation.querySelectorAll('[data-object="dimensions"] .field input')
      : [];

    if (firstStep && firstStep.classList.contains('active')) {
      lastStepButton.classList.add('hidden');
    } else {
      lastStepButton.classList.remove('hidden');
    }

    // Find the active stage and update the active class of corresponding data-stage elements
    const activeBuilderFlow = document.querySelector('.builder--flow.active');

    if (activeBuilderFlow) {
      const stageActiveValue = activeBuilderFlow
        .querySelector('[data-stageactive]')
        ?.dataset.stageactive?.toLowerCase();
      const allStages = document.querySelectorAll('[data-stage]');

      allStages.forEach((stage) => {
        const stageValue = stage.dataset.stage?.toLowerCase();
        if (stageValue === stageActiveValue) {
          stage.classList.add('active');
        } else {
          stage.classList.remove('active');
        }
      });
    }

    // Smooth scroll to the top of the page
    if (shouldScroll) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    // Validate only controls currently visible to the customer.
    // Hidden conditional fields and unrelated page forms must not block purchase.
    let allFieldsFilled = Array.from(allFields)
      .filter((field) => !field.disabled && field.offsetParent !== null)
      .every((field) => String(field.value || '').trim() !== '');

    // Disable or enable the buyDoorButton based on field values
    if (allFieldsFilled) {
      buyDoorButton.classList.remove('disabled');
    } else {
      buyDoorButton.classList.add('disabled');
    }
  }

  // Update the window.builder object with formatted key and value
  updateWindowBuilder(key, value) {
    window.builder = window.builder || {};
    window.builder[key] = this.formatString(value);
    console.log(window.builder); // Log the updated builder object
  }

  // Format a string by replacing hyphens with spaces and capitalizing each word
  formatString(str) {
    console.log('string value new', str);
    if (str === 'lay-on') {
      return 'Lay-on';
    }

    return str
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  // Method to attach click event to the Buy Now button
  attachBuyNowClickEvent() {
    // Delegate the action so it still works if Shopify re-renders the builder controls.
    document.addEventListener('click', (event) => {
      const buyNowButton = event.target.closest('.buyDoor');
      if (buyNowButton && !buyNowButton.classList.contains('disabled')) {
        event.preventDefault();
        this.buyNow();
      }
    });
  }

  // Method for handling 'Buy Now' button click
  async buyNow() {
    try {
      // Update the flow guide buttons
      const allStages = document.querySelectorAll('[data-stage]');

      allStages.forEach((stage) => {
        const stageValue = 'review';
        if (stageValue === stage.dataset.stage?.toLowerCase()) {
          stage.classList.add('active');
        } else {
          stage.classList.remove('active');
        }
      });

      // Hide flow data steps
      if (!window.location.href.includes('cart')) {
        document.querySelector('.builder--data').classList.add('hidden');
      }

      const variantId = window.builder.variantId; // Get variantId from window object
      const variantGID = `gid://shopify/ProductVariant/${variantId}`;
      // Read the visible measurement fields at purchase time so the exact
      // configuration cannot be lost if a change event was missed.
      const heightInput = document.querySelector('[data-object="dimensions"] input[name="heightmm"]');
      const widthInput = document.querySelector('[data-object="dimensions"] input[name="widthmm"]');
      // The review-page duplicate form has its own scoped measurements.
      // Only replace them when the main builder fields are actually present.
      if (heightInput && widthInput) {
        window.builder.dimensions = `Height: ${heightInput.value || ''}, Width: ${widthInput.value || ''}`;
      }

      const dimensions = await this.parseDimensions(window.builder.dimensions || '');

      // Step 1: Use the variant ID to find the product ID
      const productId = await this.fetchProductIdFromVariantId(variantGID);

      // Step 2: Fetch all variants of the product
      const productDetails = await this.fetchProductDetails(productId);

      console.log(productDetails);

      // Step 3: Find the appropriate variant based on dimensions
      const suitableVariantId = this.findSuitableVariant(
        productDetails,
        dimensions,
        variantId
      );

      const variantNumericId = suitableVariantId.split('/').pop();

      // Step 4: Add the variant to the cart
      if (suitableVariantId) {
        await this.addToCart(variantNumericId);
        await this.finalizePurchaseAndShowReview();
      } else {
        console.error('No suitable variant found');
      }
    } catch (error) {
      console.error('Error in buyNow method:', error);
    }
  }

  parseDimensions(dimensionString) {
    const dimensions = {
      height: null,
      width: null,
    };

    // Regular expressions to extract width and height
    const widthRegex = /width:\s*(\d+)/i;
    const heightRegex = /height:\s*(\d+)/i;

    // Extract width and height
    const widthMatch = dimensionString.match(widthRegex);
    const heightMatch = dimensionString.match(heightRegex);

    if (widthMatch) {
      dimensions.width = parseInt(widthMatch[1], 10);
    }
    if (heightMatch) {
      dimensions.height = parseInt(heightMatch[1], 10);
    }

    return dimensions;
  }

  async fetchProductIdFromVariantId(variantGID) {
    try {
      const graphqlQuery = {
        query: `
        {
          node(id: "${variantGID}") {
            ... on ProductVariant {
              product {
                id
              }
            }
          }
        }`,
      };

      const response = await fetch(
        'https://jmf-doors.myshopify.com/api/2024-01/graphql.json',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token':
              'f3285d862faf43dd7f4082d4ca6c962e',
          },
          body: JSON.stringify(graphqlQuery),
        }
      );

      const jsonResponse = await response.json();
      return jsonResponse.data.node.product.id;
    } catch (error) {
      console.error('Error fetching product ID from variant ID:', error);
      throw error;
    }
  }

  async fetchProductDetails(productId) {
    try {
      const graphqlQuery = {
        query: `
          {
            node(id: "${productId}") {
              ... on Product {
                id
                title
                variants(first: 100) {
                  edges {
                    node {
                      id
                      title
                      selectedOptions {
                        name
                        value
                      }
                    }
                  }
                }
              }
            }
          }`,
      };

      const response = await fetch(
        'https://jmf-doors.myshopify.com/api/2024-01/graphql.json',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token':
              'f3285d862faf43dd7f4082d4ca6c962e',
          },
          body: JSON.stringify(graphqlQuery),
        }
      );

      const jsonResponse = await response.json();
      return jsonResponse.data.node; // Returns the product details
    } catch (error) {
      console.error('Error fetching product details:', error);
      throw error;
    }
  }

  findSuitableVariant(productDetails, dimensions, originalVariantId) {
    let suitableVariantId = originalVariantId;
    let closestExcessSize = Infinity;

    productDetails.variants.edges.forEach((variant) => {
      const dimensionMatch = variant.node.title.match(/(\d+)x(\d+)/);
      if (dimensionMatch) {
        const variantHeight = parseInt(dimensionMatch[1], 10);
        const variantWidth = parseInt(dimensionMatch[2], 10);

        // Calculate the differences
        const widthDifference = variantWidth - dimensions.width;
        const heightDifference = variantHeight - dimensions.height;

        // Sum of differences; only consider variants that are equal to or larger than the target size
        if (widthDifference >= 0 && heightDifference >= 0) {
          const totalExcess = widthDifference + heightDifference;

          // Check if this variant is the closest larger match so far
          if (totalExcess < closestExcessSize) {
            closestExcessSize = totalExcess;
            suitableVariantId = variant.node.id;
          }
        }
      }
    });

    return suitableVariantId;
  }

  async updateCart(lineItemId, itemQuantity) {
    try {
      const lineItemProperties = {
        primed: window.builder.primed,
        dimensions: window.builder.dimensions,
        hingeHoles: window.builder.hingeHoles,
        hinges: window.builder.hinges,
        midrail: window.builder.midrail,
      };

      // Include hinge position properties if hingeHoles is 'Yes'
      if (window.builder.hingeHoles === 'Yes') {
        lineItemProperties.hingeSide = window.builder.hingeSide;
      }

      // Include hinge butt properties if hingeHoles is 'No'
      if (window.builder.hingeHoles === 'No') {
        lineItemProperties.hingeButt = window.builder.hingeButt;
      }

      // Include custom hinge properties if hingeHoles is 'Yes'
      if (window.builder.hingeHoles === 'Yes') {
        lineItemProperties.hingeCustom = window.builder.hingeCustom;
      }

      // Include hinge custom positions properties if hingeCustom is 'Yes'
      if (window.builder.hingeCustom === 'Yes') {
        lineItemProperties.hingeCustomPositions =
          window.builder.hingeCustomPositions;
      }

      // Include hinge butt side properties if hingeButt is 'Yes'
      if (window.builder.hingeButt === 'Yes') {
        lineItemProperties.hingeButtSide = window.builder.hingeButtSide;
      }

      // Include hinge properties if hinges is 'included'
      if (window.builder.hinges === 'Yes') {
        lineItemProperties.hingeDegree = window.builder.hingeDegree;
        lineItemProperties.hingeOption = window.builder.hingeOption;
      }

      // Include midrailHeight if midrail value is 'Custom'
      if (window.builder.midrail === 'Custom') {
        lineItemProperties.midrailHeight = window.builder.midrailHeight;
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({
          line: lineItemId,
          properties: lineItemProperties,
          quantity: itemQuantity,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error('Network response was not ok.');

      // Updates any extra costs needed for the order
      await extraCosts.updateExtraCosts();

      const jsonResponse = await response.json();
      console.log('Cart update successful:', jsonResponse);
    } catch (error) {
      console.error('Error updating cart line item properties:', error);
    }
  }

  async addToCart(variantId) {
    try {
      // Define styles for which the midrailType should be hidden
      const stylesToHideMidrail = [
        'Jacobean Shaker',
        'Beaded Jacobean',
        'Arts And Crafts',
        'Beaded Arts And Crafts',
        'Flat',
        'Finger Pull',
        'Flat Tongue And B Groove',
        'Flat Tongue And V Groove',
      ];

      // Construct line item properties from window.builder
      const lineItemProperties = {
        primed: window.builder.primed,
        dimensions: window.builder.dimensions,
        hingeHoles: window.builder.hingeHoles,
        hinges: window.builder.hinges,
      };

      // Check whether door style is not specific list
      if (!stylesToHideMidrail.includes(window.builder.style)) {
        lineItemProperties.midrail = window.builder.midrail;
      }

      // Include hinge position properties if hingeHoles is 'Yes'
      if (window.builder.hingeHoles === 'Yes') {
        lineItemProperties.hingeSide = window.builder.hingeSide;
      }

      // Include hinge butt properties if hingeHoles is 'No'
      if (window.builder.hingeHoles === 'No') {
        lineItemProperties.hingeButt = window.builder.hingeButt;
      }

      // Include custom hinge properties if hingeHoles is 'Yes'
      if (window.builder.hingeHoles === 'Yes') {
        lineItemProperties.hingeCustom = window.builder.hingeCustom;
      }

      // Include hinge custom positions properties if hingeCustom is 'Yes'
      if (window.builder.hingeCustom === 'Yes') {
        lineItemProperties.hingeCustomPositions =
          window.builder.hingeCustomPositions;
      }

      // Include hinge butt side properties if hingeButt is 'Yes'
      if (window.builder.hingeButt === 'Yes') {
        lineItemProperties.hingeButtSide = window.builder.hingeButtSide;
      }

      // Include hinge properties if hinges is 'included'
      if (
        window.builder.hinges === 'Yes' &&
        window.builder.hingeHoles === 'Yes'
      ) {
        lineItemProperties.hingeDegree = window.builder.hingeDegree;
        lineItemProperties.hingeOption = window.builder.hingeOption;
      }

      // Include midrailHeight if midrail value is 'Custom'
      if (window.builder.midrail === 'Custom') {
        lineItemProperties.midrailHeight = window.builder.midrailHeight;
      }

      console.log('jhgvjgjvj', lineItemProperties);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: lineItemProperties,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Updates any extra costs needed for the order
      await extraCosts.updateExtraCosts();

      const jsonResponse = await response.json();
      return jsonResponse; // This should be the cart object
    } catch (error) {
      console.error('Error adding item to cart:', error);
      throw error;
    }
  }

  async finalizePurchaseAndShowReview() {
    try {
      // Hide the last step of the builder flow
      const lastStepElement = document.querySelector('.builder--flow-last');
      if (lastStepElement) {
        lastStepElement.classList.add('hidden');
      }

      // Show the review section
      const reviewSection = document.querySelector('.builder--review');
      if (reviewSection) {
        reviewSection.classList.remove('hidden');
      }

      // Re-render the review section using Shopify's Section Rendering API
      const url = '/?sections=builder-review';
      const response = await fetch(url);
      const jsonResponse = await response.json(); // Parse the response as JSON

      // // Extracting the specific section's HTML content using its key
      const sectionHtml = jsonResponse['builder-review'];

      // Parse the HTML string into a document fragment
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');

      // Find the div element with the specific data-item attribute
      const elementToRender = doc.querySelector('.builder--review');

      console.log('dfghj', elementToRender);

      // Check if the fetch was successful and the section HTML is not empty
      if (reviewSection && response.ok && elementToRender) {
        // Clear review section
        reviewSection.innerHTML = '';

        // Append updated revie section
        reviewSection.appendChild(elementToRender);

        // Add click event to quantity and accessory items
        addToCart.attachEventListeners();
        accessoryAdd.init();
      } else {
        throw new Error(
          'Failed to re-render the review section or HTML content not found'
        );
      }

      // Smooth scroll to the top of the page
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      controller.eventListeners();
    } catch (error) {
      console.error('Error in finalizePurchaseAndShowReview method:', error);
    }
  }

  initDynamicForm() {
    // Attach event listeners and handle initial state
    const selects = [
      {
        id: 'hingeHolesSelect',
        dependent: [
          {
            id: 'hingeSideSelect',
            conditions: [{ id: 'hingeHolesSelect', value: 'Yes' }],
          },
          {
            id: 'hingeButtSelect',
            conditions: [{ id: 'hingeHolesSelect', value: 'No' }],
          },
          {
            id: 'hingesSelect',
            conditions: [{ id: 'hingeHolesSelect', value: 'Yes' }],
          },
          {
            id: 'hingeCustomSelect',
            conditions: [{ id: 'hingeHolesSelect', value: 'Yes' }],
          },
        ],
      },
      {
        id: 'hingeButtSelect',
        dependent: [
          {
            id: 'hingeButtSideSelect',
            conditions: [
              { id: 'hingeHolesSelect', value: 'No' },
              { id: 'hingeButtSelect', value: 'Yes' },
            ],
          },
        ],
      },
      {
        id: 'hingesSelect',
        dependent: [
          {
            id: 'hingeDegreeSelect',
            conditions: [
              { id: 'hingesSelect', value: 'Yes' },
              { id: 'hingeHolesSelect', value: 'Yes' },
            ],
          },
          {
            id: 'hingeOptionSelect',
            conditions: [
              { id: 'hingesSelect', value: 'Yes' },
              { id: 'hingeHolesSelect', value: 'Yes' },
            ],
          },
        ],
      },
      {
        id: 'hingeCustomSelect',
        dependent: [
          {
            id: 'hingeCustomPositionsSelect',
            conditions: [
              { id: 'hingeHolesSelect', value: 'Yes' },
              { id: 'hingeCustomSelect', value: 'Yes' },
            ],
          },
        ],
      },
      {
        id: 'midrailSelect',
        dependent: [
          {
            id: 'midrailHeightInput',
            conditions: [{ id: 'midrailSelect', value: 'Custom' }],
          },
        ],
      },
    ];

    selects.forEach((select) => {
      const selectElement = document.getElementById(select.id);
      if (selectElement) {
        selectElement.addEventListener('change', () =>
          this.handleSelectChange(selects)
        );
      }
    });

    // Initialize visibility based on current state
    this.handleSelectChange(selects);
    this.updateMidrailVisibility();

    // Attach event listener to door-height input for changes
    const doorHeightInput = document.querySelector(
      '.review-card--popup #door-height'
    );
    if (doorHeightInput) {
      doorHeightInput.addEventListener('input', () =>
        this.updateMidrailVisibility()
      );
    }
  }

  updateMidrailVisibility() {
    const doorHeightValue = document.querySelector(
      '.review-card--popup #door-height'
    ).value;
    const isVisible = parseInt(doorHeightValue, 10) >= 1600; // Convert and check if >= 1600

    // Select elements based on provided structure and classes
    const doorStyle = document
      .querySelector('.review-card--popup #styleSelect')
      .textContent.trim();
    const midrailTitle = document.querySelector(
      '.review-card--popup .review-card--title-midrail'
    );
    const midrailSelectField = document.querySelector(
      '.review-card--popup #midrailSelect'
    )
      ? document.getElementById('midrailSelect').closest('.field')
      : null;
    const midrailHeightField = document.querySelector(
      '.review-card--popup #midrailHeightInput'
    )
      ? document.getElementById('midrailHeightInput').closest('.field')
      : null;

    // Define styles for which the midrailType should be hidden
    const stylesToHideMidrail = [
      'Jacobean Shaker',
      'Beaded Jacobean',
      'Arts & Crafts',
      'Beaded Arts & Crafts',
      'Flat',
      'Finger Pull',
      'Flat Tongue and B Groove',
      'Flat Tongue and V Groove',
    ];

    // Toggle visibility based on door height
    if (midrailTitle) {
      midrailTitle.style.display = isVisible ? '' : 'none';
    }
    if (midrailSelectField) {
      midrailSelectField.style.display = isVisible ? '' : 'none';
    }

    if (midrailHeightField) {
      midrailHeightField.style.display = isVisible ? '' : 'none';
    }

    if (stylesToHideMidrail.includes(doorStyle)) {
      midrailHeightField.style.display = 'none';
    }
  }

  handleSelectChange(selects) {
    selects.forEach((select) => {
      select.dependent.forEach((dependency) => {
        // Evaluate all conditions for this dependency
        const allConditionsMet = dependency.conditions.every((condition) => {
          const conditionElement = document.getElementById(condition.id);
          return conditionElement && conditionElement.value === condition.value;
        });

        // Find the closest parent .field to toggle display
        const dependentElement = document.getElementById(dependency.id);
        if (dependentElement) {
          const fieldElement = dependentElement.closest('.field');
          if (fieldElement) {
            fieldElement.style.display = allConditionsMet ? '' : 'none';
          }
        }
      });
    });
  }

  toggleTitleVisibility(fieldElement, shouldShow) {
    // Assuming the title directly precedes the .field container
    let titleElement = fieldElement.previousElementSibling;
    while (
      titleElement &&
      !titleElement.classList.contains('review-card--title')
    ) {
      titleElement = titleElement.previousElementSibling;
    }

    if (titleElement && titleElement.classList.contains('review-card--title')) {
      titleElement.style.display = shouldShow ? '' : 'none';
    }
  }

  async reviewCardDuplicate(elementToRender, item) {
    window.builder = window.builder || {};

    // Scope every field to the popup belonging to the selected cart line.
    // Repeated popups contain the same field IDs, so document.getElementById()
    // can otherwise copy values from a different door.
    const field = (selector) => elementToRender.querySelector(selector);
    const value = (selector) => field(selector)?.value || '';
    const styleSelect = field('#styleSelect');
    const height = value('#door-height').trim();
    const width = value('#door-width').trim();

    if (!styleSelect || !height || !width) {
      alert('Please enter both the door height and width before adding the duplicate.');
      return;
    }

    window.builder.style =
      styleSelect.selectedOptions[0]?.text || '';
    window.builder.variantId = styleSelect.value;
    window.builder.primed = value('#primedSelect');
    window.builder.dimensions = `Height: ${height}, Width: ${width}`;
    window.builder.hingeHoles = value('#hingeHolesSelect');
    window.builder.hingeCustom = value('#hingeCustomSelect');
    window.builder.hingeCustomPositions = value('#hingeCustomPositionsSelect');
    window.builder.hinges = value('#hingesSelect');
    window.builder.hingeSide = value('#hingeSideSelect');
    window.builder.hingeButt = value('#hingeButtSelect');
    window.builder.hingeButtSide = value('#hingeButtSideSelect');
    window.builder.hingeDegree = value('#hingeDegreeSelect');
    window.builder.hingeOption = value('#hingeOptionSelect');
    window.builder.midrail = value('#midrailSelect');
    window.builder.midrailHeight = value('#midrailHeightInput')
      ? `Height: ${value('#midrailHeightInput')}`
      : '';

    const itemQuantity = item
      .closest('.builder-card--six')
      .querySelector('input[data-cart-index]').value;

    if (item.dataset.type == 'duplicate') {
      // buyNow adds the copied door and refreshes the order review.
      await doorBuilder.buyNow();
    } else {
      await doorBuilder.updateCart(item.dataset.item, itemQuantity);
      await doorBuilder.finalizePurchaseAndShowReview();
    }

    controller.removeDrawerAndPopupClasses();
  }
}
// Instantiate DoorBuilder
const doorBuilder = new DoorBuilder();